/** ColdChainBlockSlot — Y/N + (if Yes) Chill/Frozen radios.
 *  Source of truth for QA tab conditionals. Extracted verbatim from
 *  ComplianceTab.jsx. */
import { useSlotLabel } from "../hooks/useSlotLabels";

export default function ColdChainBlockSlot({ values, set }) {
  const isColdChain = values.cold_chain === "chill" || values.cold_chain === "frozen";
  const lbl = useSlotLabel("compliance.cold-chain");

  const onYesNoChange = (yes) => {
    if (yes) {
      if (!isColdChain) set("cold_chain", "chill");
    } else {
      set("cold_chain", "");
    }
  };

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50/60 p-3 space-y-3" data-testid="cold-chain-block">
      <div>
        <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
          {lbl("yn_question", "Cold-chain load?")}
        </div>
        <div className="flex gap-4 text-sm">
          <label className="inline-flex items-center gap-1.5 cursor-pointer">
            <input type="radio" name="cold-chain-yn"
                   checked={isColdChain}
                   onChange={() => onYesNoChange(true)}
                   data-testid="cold-chain-yes" />
            <span>Yes</span>
          </label>
          <label className="inline-flex items-center gap-1.5 cursor-pointer">
            <input type="radio" name="cold-chain-yn"
                   checked={!isColdChain}
                   onChange={() => onYesNoChange(false)}
                   data-testid="cold-chain-no" />
            <span>No</span>
          </label>
        </div>
      </div>

      {isColdChain && (
        <div data-testid="cold-chain-subchoice">
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
            {lbl("subchoice_question", "Chill or frozen?")}
          </div>
          <div className="flex gap-4 text-sm">
            <label className="inline-flex items-center gap-1.5 cursor-pointer">
              <input type="radio" name="cold-chain-type"
                     checked={values.cold_chain === "chill"}
                     onChange={() => set("cold_chain", "chill")}
                     data-testid="cold-chain-chill" />
              <span>Chill (+2 °C to +8 °C)</span>
            </label>
            <label className="inline-flex items-center gap-1.5 cursor-pointer">
              <input type="radio" name="cold-chain-type"
                     checked={values.cold_chain === "frozen"}
                     onChange={() => set("cold_chain", "frozen")}
                     data-testid="cold-chain-frozen" />
              <span>Frozen (≤ −18 °C)</span>
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
